module.exports = __webpack_public_path__ + "img/เนื้อปู.d729054a.jpg";